'use client';

import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from '@/lib/utils';

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      'inline-flex items-center justify-center gap-1',
      // Сегментный переключатель: и дорожка, и сама вкладка — ступень pill.
      'p-1.5 rounded-pill',
      'bg-[var(--surface)]',
      className
    )}
    {...props}
  />
));
TabsList.displayName = 'TabsList';

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'inline-flex items-center justify-center whitespace-nowrap',
      'px-4 py-2 rounded-pill',
      // t-label — роль интерактивной подписи (14/600). Заведена ответом 38 = А
      // ровно потому, что подпись активной вкладки на 14/400 читалась как
      // обычный текст. Кегль прежний, начертание стало плотнее.
      't-label',
      'transition-all duration-200',
      // Default state
      'text-[var(--text-tertiary)]',
      // Hover
      'hover:text-[var(--text-secondary)]',
      // Active state - лёгкий фиолетовый фон
      'data-[state=active]:bg-[var(--primary-subtle)] data-[state=active]:text-[var(--primary)]',
      // Focus
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--primary)]/20',
      // Disabled
      'disabled:pointer-events-none disabled:opacity-50',
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = 'TabsTrigger';

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      'mt-4',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--primary)]/30 focus-visible:ring-offset-2',
      className
    )}
    {...props}
  />
));
TabsContent.displayName = 'TabsContent';

export { Tabs, TabsList, TabsTrigger, TabsContent };
